import { useContext } from 'react';
import { DarkModeContext } from './DarkModeContext';

export const useDarkModeContext = () => {
  return useContext(DarkModeContext);
};
